var slider = (function () {
    "use strict";

    var playing = false,
        body = $('body');

    body.on('click', '.youtube', youtubeClickHandler);
    body.on('click', '.stop-button', stopClickHandler);

    var navigation = $('.flexnav').each(function () {
        var $this = $(this),
            data = $this.data(),
            width = $this.parent().width(),
            items = $this.find('.slides > li').length,
            itemWidth = width / items,
            options = {
                animation: data.type || 'slide',
                animationSpeed: data.speed || 700,
                slideshow: false,
                controlNav: false,
                directionNav: false,
                fadeInFadeOut: data.fadeinfadeout || false,
                itemWidth: itemWidth
            };

        $this.flexslider(options);
    });

    if (navigation.length === 0) {
        triggerFlexslider();
    } else {
        navigation.promise().done(triggerFlexslider);
    }

    function triggerFlexslider() {

        $('.flexslider').each(function () {
            var $this = $(this),
                navBar = $this.closest('.navigation-slider').find('.flexnav'),
                data = $this.data(),
                showControl = data.control || false,
                showCounter = data.counter || false,
                adminCounter = data.adminCounter || false,
                sync = '#' + data.nav || false,
                options = {
                    animation: data.type,
                    slideshowSpeed: data.speed,
                    slideshow: data.autostart,
                    controlNav: false,
                    prevText: "",
                    nextText: "",
                    directionNav: showControl,
                    sync: sync,
                    start: function (slider) {
                        if (showCounter) {
                            var totalSlides = slider.count,
                                controlNav = $this.find('.flex-direction-nav'),
                                counter = $('<li class="counter"><span class="current">1</span><span> av </span><span class="total">' + totalSlides + '</span></li class="counter">');

                            controlNav.append(counter);
                        }

                        if (adminCounter) {
                            var thisSlideData = $this.find('.flex-active-slide').data(),
                                counter = $this.closest('.module').find('.admin-counter'),
                                counterto = counter.find('.counter-to');

                            if (counterto != null && thisSlideData != null) {
                                counterto.html(thisSlideData.to)
                                    .end()
                                    .find('.counter-of')
                                    .html(thisSlideData.total)
                                    .end()
                                    .fadeIn(70);
                            }
                        }

                        $('.flexslider').fadeTo(80, 1);
                    },
                    after: function (slider) {
                        if (showCounter) {
                            $this.find('.current').text(slider.currentSlide + 1);
                        }

                        if (adminCounter) {
                            var thisSlideData = $this.find('.flex-active-slide').data(),
                                counter = $this.closest('.module').find('.admin-counter'),
                                counterfrom = counter.find('.counter-from');

                            if (counterfrom != null && thisSlideData != null) {
                                counterfrom.html(thisSlideData.from)
                                    .end()
                                    .find('.counter-to')
                                    .html(thisSlideData.to)
                                    .end();
                            }
                        }
                    }
                };
            $this.flexslider(options);
        });
    }


    function youtubeClickHandler(e) {
        e.preventDefault();

        var $this = $(this),
            flexslider = $this.closest('.flexslider'),
            contentSlides = $this.closest('.content-slider').find('.flexnav'),
            controlBar = $('.flexnav'),
            ytUrl = $this.data('youtube'),
            container = $this.closest('.fs-wrapper'),
            stopBtn = $('<button>', {
                'html': '&times;',
                'class': 'stop-button'
            }),
            video = $('<iframe>', {
                'class': 'video',
                'allowfullscreen': '',
                'frameborder': '0',
                'width': container.width(),
                'height': container.height(),
                'src': ytUrl + "?autoplay=1&showinfo=0&color=white&controls=1"
            }),
            flexControls = flexslider.find('.flex-control-nav, .flex-direction-nav');

        if (!playing) {
            flexControls.fadeOut(250);
            contentSlides.fadeOut(250);
            container.find('.slides').fadeOut(250, function () {
                container.append(video, stopBtn);
                video.load(function () {
                    video.css('visibility', 'visible');
                    $('.stop-button').fadeIn(250);
                });
            });
        }

        playing = true;
    }

    function stopClickHandler(e) {

        var $this = $(this),
            iframe = $this.prev(),
            container = $this.closest('.fs-wrapper'),
            navBar = container.find('.flexnav'),
            flexControls = container.find('.flex-control-nav, .flex-direction-nav');;

        $this.prev().remove();
        $this.remove();
        flexControls.fadeIn(250);
        container.find('.slides').fadeIn(250);
        navBar.fadeIn(250);
        playing = false;
    }

})();